import React from 'react';


import Backdrop from './Backdrop';

import styled from 'styled-components';


const Spinner = styled.div`
    width: 30%;
    padding: 2%;
    position: fixed;
    z-index: 7000;
    box-sizing: border-box;
    text-align: center;
    top: 25%;
    left: calc(35%);
    background: white;
    border-radius: 5px;
`
const commonModal = (props) => (
   <div>
     <Backdrop clicked={props.closeModal} show={props.show} />
     <Spinner
     style={{
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? '1': '0'

    }}
     >
      {props.children}
    </Spinner>
   </div>
);

export default commonModal;